import { useState, useEffect } from "react";
import { api, errMsg } from "../lib/api";
import { toast } from "sonner";
import { MessageCircleQuestion } from "lucide-react";

export const LectureQA = ({ courseId, lectureId, onAnswersSeen }) => {
  const [qs, setQs] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!lectureId) return;
    api.get(`/courses/${courseId}/questions?lecture_id=${lectureId}`)
      .then((r) => {
        setQs(r.data);
        api.post("/qa/mark-seen", { course_id: courseId, lecture_id: lectureId })
          .then(() => onAnswersSeen && onAnswersSeen(lectureId)).catch(() => {});
      }).catch(() => setQs([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseId, lectureId]);

  const ask = async (e) => {
    e.preventDefault();
    if (!text.trim() || busy) return;
    setBusy(true);
    try {
      const r = await api.post("/questions", { course_id: courseId, lecture_id: lectureId, text: text.trim() });
      setQs((prev) => [r.data, ...prev]);
      setText("");
      toast.success("Question posted — the instructor will reply soon!");
    } catch (e2) { toast.error(errMsg(e2)); }
    setBusy(false);
  };

  return (
    <div className="mt-6" data-testid="lecture-qa-section">
      <h3 className="font-display font-bold text-sm mb-3 flex items-center gap-2" style={{ letterSpacing: 1 }}>
        <MessageCircleQuestion size={16} style={{ color: "var(--bp)" }} /> Q&A — THIS LECTURE
      </h3>
      <form onSubmit={ask} className="flex gap-2 mb-4">
        <input data-testid="qa-question-input" value={text} onChange={(e) => setText(e.target.value)}
          placeholder="Ask the instructor a question about this lecture…" maxLength={2000}
          className="input-dark text-sm flex-1" />
        <button data-testid="qa-ask-btn" disabled={busy || !text.trim()}
          className="btn-primary !py-2 text-sm disabled:opacity-40">ASK</button>
      </form>
      {qs.length === 0 && (
        <p className="text-sm" style={{ color: "var(--muted)" }} data-testid="qa-empty">
          No questions yet on this lecture — be the first to ask.
        </p>
      )}
      <div className="space-y-3">
        {qs.map((q) => (
          <div key={q.id} className="forge-card !transform-none p-4" data-testid={`qa-question-${q.id}`}>
            <div className="flex items-center justify-between">
              <p className="text-sm font-semibold">{q.user_name}</p>
              <span className="text-xs" style={{ color: "var(--muted)" }}>{new Date(q.created_at).toLocaleDateString()}</span>
            </div>
            <p className="text-sm mt-1 whitespace-pre-line">{q.text}</p>
            {q.answer ? (
              <div className="mt-3 pl-3 py-2 rounded" style={{ borderLeft: "2px solid var(--gold)", background: "rgba(230,181,74,.06)" }}>
                <span className="font-display text-[10px] font-bold px-1.5 py-0.5 rounded"
                  style={{ background: "var(--gold)", color: "#14100a", letterSpacing: 1.5 }} data-testid={`qa-instructor-badge-${q.id}`}>
                  INSTRUCTOR
                </span>
                <p className="text-sm mt-1.5 whitespace-pre-line">{q.answer}</p>
              </div>
            ) : (
              <p className="text-xs mt-2" style={{ color: "var(--muted)" }}>Awaiting instructor reply…</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
